<template>
  <ul class="breadcrumb">
    <li v-for="item in list"
        :key="item.link"
        class="breadcrumb-item">
      <router-link v-if="item.link"
                   :to="item.link">
        {{ item.name }}
      </router-link>
      <span v-else>{{ item.name }}</span>
    </li>
  </ul>
</template>
<script>
export default {
	name: 'breadcrumb',
	data () {
		return {
			list: []
		}
	},
	watch: { '$route' () { this.updateBreadcrumList() } },
	mounted () { this.updateBreadcrumList() },
	methods: {
		updateBreadcrumList () {
			this.list = this.$route.meta.breadcrumb
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/breadCrumb/index.vue